<template>
  <div style="overflow-x: hidden !important">
    <div class="profile-card">
      <div class="profile-header">
        <div
          alt="Avatar"
          class="avatar m-0"
          :style="{
            backgroundImage: profile_data?.photo
              ? `url('https://dev-server.nuxtgen.net${profile_data.photo}')`
              : null,
            backgroundColor: profile_data?.photo
              ? null
              : 'hsla(0, 0%, 50%, 0.199)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }"
        />

        <h2 class="name m-0">{{ profile_data?.user?.username }}</h2>
        <span
          class="role mt-2 bg-success text-black"
          style="color: black !important; font-weight: 600"
          >{{ profile_data?.user_role?.name }}</span
        >
      </div>

      <div class="details pt-0 m-0 mb-3" style="font-size: 13px !important">
        <p style="font-size: 14px !important">
          <span>User Name:</span> {{ profile_data?.user?.username }}
        </p>
        <p style="font-size: 14px !important">
          <span>Email:</span> {{ profile_data?.user?.email }}
        </p>

        <!-- <p style="font-size: 14px !important"><span>Role:</span> Editor</p> -->
        <p style="font-size: 14px !important">
          <span>Isp Name:</span> {{ profile_data?.isp_name }}
        </p>
        <p style="font-size: 14px !important">
          <span>Contact Number:</span> {{ profile_data?.number }}
        </p>
        <!-- <p style="font-size: 14px !important"><span>Language:</span> English</p> -->
        <p style="font-size: 14px !important">
          <span>Address:</span> {{ profile_data?.address }}
        </p>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="bg-success btn-sm btn text-white rounded"
          style="width: 150px !important"
        >
          Edit
        </button>
      </div>
    </div>

    <!-- ############### previous page ######### -->

    <div class="row">
      <div class="col-12 mb-5">
        <div
          id=" p-6"
          class="card mt-4 _card-bg"
          style="max-width: 500px !important; margin: 0 auto !important"
        >
          <div class="card-header _card-bg">
            <div class="col-sm-auto col-8 my-auto">
              <div class="h-100">
                <button class="btn btn-success btn-sm rounded" @click="getVpn">
                  Add VPN
                </button>
              </div>
            </div>

            <div class="d-flex flex-column">
              <p
                v-if="vpn_data.error"
                style="color: red !important; margin-bottom: 5px"
              >
                * {{ vpn_data.error }}
              </p>
              <p v-if="vpn_data.message" style="color: red !important">
                * {{ vpn_data.message }}
              </p>
            </div>
          </div>

          <div class="d-flex p-3">
            <div v-if="vpn_data" class="w-100">
              <!-- Display Fields -->
              <div class="">
                <span class="_label">Connection Name:</span><br />
                <div class="d-flex" style="gap: 20px !important">
                  <input
                    v-model="vpn_data.connection_name"
                    type="text"
                    class="rounded w-100"
                    readonly
                  />
                  <button
                    class="copy-btn"
                    @click="copyToClipboard('connection_name')"
                  >
                    Copy
                  </button>
                </div>
              </div>

              <div>
                <span class="_label">PPPoE Username:</span><br />
                <div class="d-flex" style="gap: 20px !important">
                  <input
                    v-model="vpn_data.pppoe_username"
                    type="text"
                    class="rounded w-100"
                    readonly
                  />
                  <button
                    class="copy-btn"
                    @click="copyToClipboard('pppoe_username')"
                  >
                    Copy
                  </button>
                </div>
              </div>

              <div>
                <span class="_label">PPPoE Password:</span><br />
                <div class="d-flex" style="gap: 20px !important">
                  <input
                    v-model="vpn_data.pppoe_password"
                    type="text"
                    class="rounded w-100"
                    readonly
                  />
                  <button
                    class="copy-btn"
                    @click="copyToClipboard('pppoe_password')"
                  >
                    Copy
                  </button>
                </div>
              </div>

              <div>
                <span class="_label">Command:</span><br />

                <div class="d-flex" style="gap: 20px !important">
                  <input
                    v-model="vpn_data.command"
                    type="text"
                    class="rounded w-100"
                    readonly
                  />
                  <button class="copy-btn" @click="copyToClipboard('command')">
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from "/src/mixins/form-mixin.js";
import img from "/src/assets/img/bruce-mars.jpg";
import showSwal from "/src/mixins/showSwal.js";
import { useVpnApi } from "../services/vpn.service";
import getProfileCheck from "@/services/check-profile.service";

export default {
  name: "Profile",
  components: {},
  mixins: [formMixin],
  data() {
    const passChange = {
      password: "",
      password_confirmation: "",
    };
    const profile_data = [];
    const profileChange = {
      user_name: "",
      id: "",
    };
    const vpn_data = [];
    return {
      passChange,
      profileChange,
      loading: false,
      loading2: false,
      img,
      vpn_data,
      profile_data,
    };
  },
  computed: {
    profile() {
      return this.$store.getters["profile/profile"];
    },
    pic() {
      if (this.profile.profile_image) return this.profile.profile_image;
      else return require("/src/assets/img/placeholder.jpg");
    },
  },
  mounted() {
    this.getCheckProfile();
  },
  async created() {
    try {
      await this.$store.dispatch("profile/getProfile");
      this.profileChange = { ...this.profile };
    } catch (error) {
      console.error("Error loading profile:", error.message || error);
    }
  },
  methods: {
    async getCheckProfile() {
      try {
        let response = await getProfileCheck.getProfileCheck();
        this.profile_data = response;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    copyToClipboard(field) {
      const textToCopy = this.vpn_data[field];
      const tempInput = document.createElement("input");
      tempInput.value = textToCopy;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      showSwal.methods.showSwal({
        type: "success",
        message: `${field} copied!`,
        width: 450,
      });
    },
    async getVpn() {
      try {
        const { checkVpn } = useVpnApi();
        const userId = this.profile.fendy_user_id;
        this.vpn_data = await checkVpn(userId);
        showSwal.methods.showSwal({
          type: "success",
          message: "VPN Added Successfully!",
          width: 450,
        });
        console.log("VPN Data:", this.vpn_data);
      } catch (error) {
        this.vpn_data = error.response.data;
        console.error("Error retrieving VPN data:", error);
      }
    },

    async handlePassChange() {
      const isDemoMode = (process.env.VUE_APP_IS_DEMO ?? 1) == 1;
      if (isDemoMode && this.profile.id <= 3) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You cannot change data of default users!",
          width: 450,
        });
        return;
      }

      this.resetApiValidation();
      this.loading = true;

      try {
        await this.$store.dispatch("profile/updateProfile", this.passChange);
        showSwal.methods.showSwal({
          type: "success",
          message: "Password changed successfully!",
          width: 500,
        });
        this.passChange.password = "";
        this.passChange.password_confirmation = "";
        this.loading = false;
      } catch (error) {
        this.setApiValidation(error.response.data.errors);
        this.loading = false;
      }
    },

    async handleProfileChange() {
      const isDemoMode = (process.env.VUE_APP_IS_DEMO ?? 1) == 1;
      if (isDemoMode && this.profile.id <= 3) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You cannot change data of default users!",
          width: 450,
        });
        return;
      }

      this.resetApiValidation();
      this.loading2 = true;

      try {
        await this.$store.dispatch("profile/updateProfile", this.profileChange);
        showSwal.methods.showSwal({
          type: "success",
          message: "Profile updated successfully!",
          width: 600,
        });
        this.loading2 = false;
      } catch (error) {
        console.error("Error updating profile:", error.message || error);
        this.setApiValidation(error.response.data.errors);
        this.loading2 = false;
      }
    },
  },
};
</script>

<style>
/* Container Styles */
.profile-card {
  background-color: white;
  color: black;
  max-width: 500px;
  margin: 20px auto;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  font-family: Arial, sans-serif;
}

._card-bg {
  background-color: white !important;
}

.dark-mode ._card-bg {
  background-color: #4e89ff1a !important;
}

.dark-mode .profile-card {
  background-color: #4e89ff1a;
}
.details span {
  font-weight: 600 !important;
}

/* Header Section */
.profile-header {
  text-align: center;
}

.avatar {
  width: 150px !important;
  height: 150px !important;
  margin-bottom: 10px;
}

.name {
  font-size: 1.5rem;
  margin: 10px 0 5px 0;
}

.role {
  display: inline-block;
  background-color: #4c4cff;
  color: white;
  font-size: 0.8rem;
  padding: 4px 12px;
  border-radius: 8px;
  margin-bottom: 15px;
}

/* Stats Section */
.stats {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  text-align: center;
}

.stat {
  flex: 1;
}

.stat-value {
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
}

.stat-label {
  font-size: 0.9rem;
  color: #bbbbbb;
}

/* Details Section */
.details {
  padding: 15px;
  border-radius: 8px;
  font-size: 0.9rem;
  margin-bottom: 20px;
}

.details p {
  margin: 5px 0;
}

.status-active {
  background-color: #4caf50;
  color: white;
  padding: 2px 6px;
  border-radius: 6px;
}

/* Actions Section */
.actions {
  display: flex;
  justify-content: space-between;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.edit-btn {
  background-color: #6c63ff;
  color: white;
}

.edit-btn:hover {
  background-color: #5a54d9;
}

.suspend-btn {
  background-color: #ff5252;
  color: white;
}

.suspend-btn:hover {
  background-color: #e64a4a;
}

.copy-btn {
  border-radius: 8px !important;
  font-weight: 600;
  font-size: 13px !important;
}
._label {
  font-size: 14px !important;
}
</style>
